import { render, staticRenderFns } from "./DCIDetail.vue?vue&type=template&id=df25507e&scoped=true"
import script from "./DCIDetail.vue?vue&type=script&lang=js"
export * from "./DCIDetail.vue?vue&type=script&lang=js"
import style0 from "./DCIDetail.vue?vue&type=style&index=0&id=df25507e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df25507e",
  null
  
)

export default component.exports